import MultiTouch from 'mapbox-gl-multitouch';
export default class Map {
    constructor() {
        this.selector = 'map';
        this.init();
    }

    init() {
        if ( typeof mapboxData !== "undefined" && mapboxData.hasOwnProperty( 'accessToken' ) ) {
            mapboxgl.accessToken = mapboxData.accessToken;

            let mapsElement = document.querySelectorAll( '[data-map]' );

            if( mapsElement.length < 1 ) {
                return;
            }
            
            mapsElement.forEach( ( element ) => {
                let map = new mapboxgl.Map( {
                    container: element,
                    style: mapboxData.style,
                    center: [mapboxData.location.lng, mapboxData.location.lat],
                    zoom: 15,
                    attributionControl: false,
                    scrollZoom: false,
                    boxZoom: true
                } );

                let nav = new mapboxgl.NavigationControl();
                map.addControl(nav, 'bottom-right');
                map.addControl(new MultiTouch());

                let defaultMarker = this.createMarker(mapboxData.location, 0, '');
                defaultMarker.classList.add( 'map__marker--main' );

                new mapboxgl.Marker(defaultMarker)
                    .setLngLat([mapboxData.location.lng, mapboxData.location.lat])
                    .addTo(map);

				document.body.addEventListener( 'refresh-view', (e) => {
					map.resize();
				} );

                window.addEventListener( 'popstate', (e) => {
					map.resize();
				} );
            } )
        
        }
    }

    createMarker(data, target, inner = '') {
        let markerEl = document.createElement('div');

        markerEl.className = 'map__marker';
        markerEl.setAttribute( 'data-map-target', target );
        markerEl.setAttribute( 'data-map-coordinates', JSON.stringify( [ data.lng, data.lat ] ) );

        var markerInner = document.createElement('div');
        markerInner.className = 'map__marker__inner';
        markerInner.innerHTML = inner;

        markerEl.appendChild( markerInner );

        return markerEl;
    }
}